export default function runLater(functionToRunLater, milliseconds) {
  milliseconds = milliseconds !== null && milliseconds !== void 0 ? milliseconds : 0;
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(functionToRunLater());
      } catch (e) {
        reject(e);
      }
    }, milliseconds);
  });
}